import SimpleCard, { ECardIcon, ICardProperties } from "components/controls/SimpleCard";
import * as FAM from "model/FlexibleAttributeModel";

export interface IAccountsReceivableCard extends ICardProperties {
    accountsReceivable: FAM.IAccountsReceivable;
}

const AccountsReceivableCard: React.FC<IAccountsReceivableCard> = (props) => {
    const { accountsReceivable } = props;
    return <SimpleCard
        key={accountsReceivable.id}
        header="AR"
        description={accountsReceivable.name ?? ""}
        {...props}
    />
}

export default AccountsReceivableCard;